import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-datamanagement',
  templateUrl: './datamanagement.component.html',
  styleUrls: ['./datamanagement.component.scss']
})
export class DatamanagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
